import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Debug logging
const logDebug = (window as unknown as { logDebug?: (msg: string) => void }).logDebug || console.log.bind(console);
logDebug('main.tsx executing');

try {
  const root = document.getElementById('root');
  if (root) {
    // Remove loading screen when React mounts
    const loadingScreen = document.getElementById('loading-screen');
    logDebug('Creating React root');

    createRoot(root).render(
      <StrictMode>
        <App />
      </StrictMode>
    );

    logDebug('React render called');

    // Remove loading screen after a short delay to ensure React has mounted
    setTimeout(() => {
      if (loadingScreen) {
        loadingScreen.style.display = 'none';
        logDebug('Loading screen hidden');
      }
    }, 100);
  } else {
    logDebug('ERROR: #root element not found');
  }
} catch (error) {
  logDebug('ERROR: ' + String(error));
}
